import React from 'react';
import { cn } from '@/lib/utils';

export interface SectionProps {
  title?: string;
  /** Optional action (e.g. link or button) in the header row */
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * Panel wrapper for content blocks. Console-density: tight padding, md radius, no shadow.
 */
export const Section: React.FC<SectionProps> = ({
  title,
  action,
  children,
  className,
}) => {
  return (
    <section
      className={cn(
        'rounded-md border border-border bg-card text-card-foreground overflow-hidden',
        className
      )}
    >
      {(title != null || action != null) && (
        <div className="flex items-center justify-between gap-4 border-b border-border px-3 py-2">
          {title != null && (
            <h2 className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              {title}
            </h2>
          )}
          {action != null && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className="p-3">{children}</div>
    </section>
  );
};

export default Section;
